export default {
  AUTH_TOKEN: {
    GRANT_TYPE: 'authorization_code',
    CONTENT_TYPE: 'application/x-www-form-urlencoded',
  },
  UPLOAD_PDF: {
    MAX_FILE_SIZE_MB: 50,
    MAX_PAGES: 2,
    MAX_PAGE_WIDTH_MM: 216,
    MAX_PAGE_HEIGHT_MM: 154,
    ACCEPTED_FILE_TYPE: 'application/pdf',
    UPLOAD_FOLDER: 'validation',
    UPLOAD_FILENAME: 'material.pdf',
    INPUT_DEFAULT_VALUE: 'Postcard',
    INPUT_DEFAULT_VALUE_SV: 'Utskick',
  },
  MAILOUT: {
    MARKET: 'SE',
    SERVICE: 'admail-postcard',
    EXCEL_UPLOAD_BUCKET: 'skapa-utskick-exceluploads-test-v1',
    UPLOAD_FOLDER: 'csv',
    MIN_ADDRESS_COUNT: 100,
    MAX_ADDRESS_COUNT: 30000,
  },
  VUE_API_WAIT_TIME: 1000, // Simulated wait time for mock API responses in milliseconds
  VUE_APP_INVOICE_FOR_NCP: true, // When true and user is a business user, INVOICE payment option is shown alongside CARD
  HOME: {
    PRODUCT_ID: '6000',
    COST: {
      RECEIVERS: [100, 500, 5000, 10000],
    },
    POSTAL_SERVICE_URL: 'https://portal.postnord.com/posttjanster/#/',
    PRICE_LIST_PRIVATE_URL:
      'https://www.postnord.se/privat/priser-och-villkor/prislistor-privatkunder/',
    PRICE_LIST_BUSINESS_URL:
      'https://www.postnord.se/foretag/priser-och-villkor/prislistor-avtalskunder/',
    PRICE_LIST_PRIVATE_URL_EN:
      'https://www.postnord.se/en/private/prices-terms-and-conditions-for-private-individuals/price-lists-for-private-customers/',
    PRICE_LIST_BUSINESS_URL_EN:
      'https://www.postnord.se/en/business/prices-and-terms-for-businesses/price-lists-for-service-agreement-customers/',
  },
  ORDER: {
    ADDRESS_TYPE: 'ADR',
    TARGET_TYPE: 'FILE',
    PAYMENT_METHOD: 'CARD',
    DELIVERY_ID: '400',
    PREFACE_PAGE: false,
    REDIRECT_URL: '/order-confirmation?orderId=%ORDERID%',
    CANCEL_URL: '/order',
    NEW_CHECKOUT: true, // When true, users are redirected to a new checkout flow hosted by PostNord. Otherwise, they are redirected to the old checkout flow.
    SENDER_COUNTRY: 'Sweden',
  },
  CONTACTINFO: {
    REGEX: {
      EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      POSTAL_CODE: /^\d{5}$/, //
      MOBILE: /^\+\d{8,15}$/, // between 8 and 15 digits, leading +
    },
    ATTRIBUTES: {
      FIRSTNAME: 'firstname',
      LASTNAME: 'lastname',
      ADDRESS: 'address',
      CITY: 'city',
      POSTALCODE: 'postalcode',
      EMAIL: 'email',
      MOBILE: 'mobile',
    },
  },
  MY_ORDER_SECTION: {
    EXCEL: 'excel',
    PDF: 'pdf',
    DELIVERY: 'delivery',
    CONTACT: 'contact',
    PAYMENT: 'payment',
    PAYMENT_STATUS: {
      NONE: '',
      INITIATED: 'initiated',
      FAILED: 'failed',
    },
  } as const,
  MY_ORDER_STATUS: {
    PLACED: 'PLACED',
    UNPROCESSED: 'UNPROCESSED',
    PROCESSED: 'PROCESSED',
    STARTED: 'STARTED',
    DELIVERED: 'DELIVERED',
  },
  EXTERNAL: {
    CONTACT_US_URL: 'https://www.postnord.se/en/contact-us/',
  },
  DELIVERY: {
    CALENDAR_DATE_FORMAT: /^\d{4}-\d{2}-\d{2}$/,
    MINIMUM_ORDER_LEAD_BUSINESS_DAYS: 7,
    SWEDEN_TIME_ZONE: 'Europe/Stockholm',
  },
  ORDER_SUMMARY: {
    GENERAL_TERMS_AND_CONDITIONS_URL_EN:
      'https://www.postnord.se/en/business/prices-and-terms-for-businesses/',
    GENERAL_TERMS_AND_CONDITIONS_URL_SV: 'https://www.postnord.se/foretag/priser-och-villkor/',
    SPECIAL_TERMS_AND_CONDITIONS_BUSINESS_URL_EN:
      'https://www.postnord.se/en/business/prices-and-terms-for-businesses/special-terms-and-conditions-for-service-agreement-customers/',
    SPECIAL_TERMS_AND_CONDITIONS_BUSINESS_URL_SV:
      'https://www.postnord.se/foretag/priser-och-villkor/tjanstevillkor-avtalskunder/',
    SPECIAL_TERMS_AND_CONDITIONS_PRIVATE_URL_EN:
      'https://www.postnord.se/en/private/prices-terms-and-conditions-for-private-individuals/service-terms-and-conditions-for-private-individuals/',
    SPECIAL_TERMS_AND_CONDITIONS_PRIVATE_URL_SV:
      'https://www.postnord.se/privat/priser-och-villkor/tjanstevillkor-privatkunder/',
    PRIVACY_POLICY_URL_EN: 'https://www.postnord.se/en/privacy-policy/',
    PRIVACY_POLICY_URL_SV: 'https://www.postnord.se/integritetspolicy/',
  },
  GTM_TAGS: {
    GO_TO_ORDER: { event: 'start_button' },
    PDF_UPLOADED: { event: 'design_uploaded' },
    RECIPIENTS_UPLOADED: { event: 'recipients_uploaded' },
    DELIVERY_SELECTED: { event: 'mail_out_date_selected' },
    CONTACT_ADDED: { event: 'sender_info_added' },
    BEGIN_CHECKOUT: { event: 'begin_checkout' },
    PURCHASE: { event: 'purchase' },
  },
};
